<template>
  <div class="partners-item">
    <template
      v-if="fields && fields.link && fields.link.value.href && fields.link.value.href.length > 0"
    >
      <sc-link class="link" v-if="fields && fields.link" :field="fields.link">
        <sc-image class="img" v-if="fields && fields.image" :media="fields.image" />
      </sc-link>
    </template>
    <template v-else>
      <sc-image class="img" v-if="fields && fields.image" :media="fields.image" />
    </template>
  </div>
</template>

<script>
import { Image, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Partners-Item',
  components: {
    ScImage: Image,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
